import JSZip from 'jszip';

export const parseXMindToMarkdown = async (file: File): Promise<string> => {
  const zip = new JSZip();
  const contents = await zip.loadAsync(file);

  if (contents.file('content.json')) {
    const jsonString = await contents.file('content.json')!.async('string');
    try {
      const data = JSON.parse(jsonString);
      return parseXMindJsonToMarkdown(data);
    } catch (e) {
      throw new Error("Failed to parse XMind JSON format.");
    }
  } else if (contents.file('content.xml')) {
    const xmlString = await contents.file('content.xml')!.async('string');
    try {
      return parseXMindXmlToMarkdown(xmlString);
    } catch (e) {
      throw new Error("Failed to parse XMind XML format.");
    }
  } else {
    throw new Error("Invalid XMind file: Missing content.json or content.xml");
  }
};

const parseXMindJsonToMarkdown = (data: any[]): string => {
  if (!Array.isArray(data) || data.length === 0 || !data[0].rootTopic) {
    throw new Error("Invalid XMind JSON structure: No rootTopic found.");
  }
  
  const rootTopic = data[0].rootTopic;
  let markdown = `# ${rootTopic.title || 'Root'}\n`;
  
  if (rootTopic.children && rootTopic.children.attached) {
    rootTopic.children.attached.forEach((child: any) => {
      markdown += buildJsonMarkdownRec(child, 0);
    });
  }
  
  return markdown;
};

const buildJsonMarkdownRec = (topic: any, depth: number): string => {
  const indent = '  '.repeat(depth);
  let md = `${indent}- ${topic.title || 'Untitled'}\n`;
  
  if (topic.children && topic.children.attached) {
    topic.children.attached.forEach((child: any) => {
      md += buildJsonMarkdownRec(child, depth + 1);
    });
  }
  
  return md;
};

const parseXMindXmlToMarkdown = (xmlString: string): string => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
  
  const rootTopic = xmlDoc.querySelector('sheet > topic');
  if (!rootTopic) {
    throw new Error("Invalid XMind XML structure: No root topic found.");
  }
  
  const titleEl = rootTopic.querySelector(':scope > title');
  const title = titleEl ? titleEl.textContent || 'Root' : 'Root';
  let markdown = `# ${title}\n`;
  
  const attachedTopics = rootTopic.querySelector(':scope > children > topics[type="attached"]');
  if (attachedTopics) {
    Array.from(attachedTopics.children).forEach(child => {
      if (child.tagName === 'topic') {
        markdown += buildXmlMarkdownRec(child, 0);
      }
    });
  }
  
  return markdown;
};

const buildXmlMarkdownRec = (topicNode: Element, depth: number): string => {
  const indent = '  '.repeat(depth);
  const titleEl = topicNode.querySelector(':scope > title');
  const title = titleEl ? titleEl.textContent || 'Untitled' : 'Untitled';
  
  let md = `${indent}- ${title}\n`;
  
  const attachedTopics = topicNode.querySelector(':scope > children > topics[type="attached"]');
  if (attachedTopics) {
    Array.from(attachedTopics.children).forEach(child => {
      if (child.tagName === 'topic') {
        md += buildXmlMarkdownRec(child, depth + 1);
      }
    });
  }
  
  return md;
};
